export class RequestActionModel {
  no: number;
  description: string;
  current_status: string;
  state: string;
}
